import {useQuery} from "react-query"
import useAuth from "auth/useAuth"

export default function useRescuerRescues(username) {

    const {auth, API} = useAuth()

    const query = useQuery(
        ["rescuer-rescues", username],
        () => auth(API.rescuersIdRescuesGet, {id: username}).then(response => response.data),
        {
            enabled: !!username,
            staleTime: 1000 * 60 * 5 // 5 minutes
        }
    )

    return query
}
